import { selling_points, refill_points } from './selling_points'

const ymapsScript = document.createElement('script')
ymapsScript.src = `https://api-maps.yandex.ru/2.1/?lang=ru_RU&apikey=405e6ebe-d78e-49cf-ae1f-db3391b6c3da`
ymapsScript.type = 'text/javascript'
document.getElementsByTagName('head')[0].appendChild(ymapsScript)

ymapsScript.onload = _ => {
  initMap()
}

const initMap = _ => {
  ymaps.ready(_ => {
    const map = new ymaps.Map ("selling_points", {
      center: [56.85963273944647,35.889990999999974], 
      zoom: 12,
      controls: ['searchControl', 'zoomControl']
    })

    const Clusterer = new ymaps.Clusterer({
      name: `clusterer_${Date.now()}`,
      gridSize: 16,
    })
    map.geoObjects.add(Clusterer)

    const { widgetType } = global

    const points = widgetType === 'sell' ? selling_points : refill_points

    points.forEach(point => {
      const Point = new ymaps.GeoObject({
        geometry: {
          type: 'Point',
          coordinates: point.coords,
        },
        properties: {
          balloonContentHeader: point.type,
          balloonContentBody: point.adress,
        }
      },
      {
        iconLayout: 'default#image',
        iconImageHref: require('./point.svg'),
        iconImageSize: [18, 26],
        iconImageOffset: [-9, -26],
      })

      Clusterer.add(Point)
    })
  })
}
